module.exports = __webpack_public_path__ + "static/media/contacts2.1079432f.png";